import axios from 'axios';

// In development, use an empty baseURL so requests are relative and routed
// through the CRA dev-server proxy (port 3006 → 3004, WSL→WSL).
// In production, call the live server directly.
const isDev = process.env.NODE_ENV === 'development';
const baseURL = isDev ? '' : 'https://www.lonnii.com';

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Login, 2FA, admin accounts and audit are served by the dashboard's own login
// service on this site's server (its own database), so they keep working when
// www.lonnii.com is down. Everything else goes to www.lonnii.com.
export const AUTH_PATH = /^\/dashboard-admin\/(login|logout|heartbeat|2fa\/|me(\/password)?(\?|$)|check-permission\/|admins(\/|\?|$)|permissions(\?|$)|audit(\?|$)|confirm-password|system-status)/;

// Request interceptor
api.interceptors.request.use(
  (config) => {
    if (AUTH_PATH.test(config.url || '')) {
      config.baseURL = '';
    }
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // skipAuthRedirect: the Lonnii Desktop server checks the login separately; if it refuses
    // (not updated yet, key missing) the page says so instead of logging the admin out.
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
